'use client';

import Image from 'next/image';
import { useState } from 'react';
import team from '@/data/team.json';

export default function TeamGrid() {
  const [selected, setSelected] = useState<number | null>(null);

  return (
    <section className="py-12">
      <h2 className="text-3xl font-bold text-c2e-blue text-center mb-10">L'équipe C2E</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
        {team.map((member, idx) => (
          <button
            key={member.id}
            className="group relative rounded-2xl overflow-hidden shadow-lg bg-white hover:shadow-2xl transition-all focus:outline-none"
            onClick={() => setSelected(idx)}
            aria-label={`Voir le profil de ${member.firstName} ${member.lastName}`}
          >
            <div className="relative w-full aspect-[4/5] bg-c2e-gray-light">
              <Image
                src={member.image}
                alt={member.firstName + ' ' + member.lastName}
                fill
                className="object-cover group-hover:scale-105 transition-transform"
                sizes="(max-width: 768px) 100vw, 25vw"
                priority={idx < 2}
                unoptimized
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-80 group-hover:opacity-60 transition-opacity" />
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-white/80 backdrop-blur-sm">
              <h3 className="text-lg font-bold text-c2e-blue mb-1">{member.firstName} {member.lastName}</h3>
              <p className="text-xs text-gray-700">{member.role}</p>
            </div>
          </button>
        ))}
      </div>

      {/* Modale membre */}
      {selected !== null && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60" onClick={() => setSelected(null)}>
          <div
            className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative animate-fade-in"
            onClick={e => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <button
              className="absolute top-4 right-4 text-c2e-blue hover:text-c2e-red text-2xl font-bold"
              onClick={() => setSelected(null)}
              aria-label="Fermer"
            >
              ×
            </button>
            <div className="flex flex-col items-center">
              <div className="relative w-32 h-40 rounded-xl overflow-hidden mb-4">
                <Image
                  src={team[selected].image}
                  alt={team[selected].firstName + ' ' + team[selected].lastName}
                  fill
                  className="object-cover"
                  sizes="128px"
                  unoptimized
                />
              </div>
              <h3 className="text-xl font-bold text-c2e-blue mb-1">{team[selected].firstName} {team[selected].lastName}</h3>
              <p className="text-sm text-gray-700 mb-2">{team[selected].role}</p>
              <p className="text-gray-600 italic text-center mb-2">{team[selected].bio}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
